import Image from "next/image";
import { ArrowIcons, ClockSvg } from "@/components/svg";
import Link from "next/link";
import { constants } from "@/constants";
import { getLocalizedPath, ifArabic } from "@/utils/language";
import { truncate } from "@/utils";
import { useLanguage } from "@/app/[lang]/client/language-context";

type IProps = {
  blog: any;
};

export default function BlogItem({ blog }: IProps) {
  const { language } = useLanguage();

  function convertToDate(dateString: any) {
    const timestamp = dateString.match(/\d+/)[0];
    const date = new Date(parseInt(timestamp, 10));
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <div
      className="tp-blog-item text-center mb-40 wow fadeInLeft"
      data-wow-delay=".4s"
    >
      <div className="tp-blog-thumb fix">
        <Link
          aria-label="Blog Image"
          href={getLocalizedPath(`/news/${blog.UniqueUrl}`, language)}
        >
          <div
            style={{
              width: "100%",
              height: 220,
            }}
          >
            <Image
              src={constants.UPLOAD_BASE_URL + blog.MainImage}
              alt={ifArabic(blog.TitleAr, blog.Title)}
              width={559}
              height={350}
            />
          </div>
        </Link>
      </div>
      <div className="tp-blog-content">
        {/* <span className="tp-blog-tag">News</span> */}
        {blog?.Title && (
          <h3 className="tp-blog-title">
            <Link
              aria-label="Blog Title"
              href={getLocalizedPath(`/news/${blog.UniqueUrl}`, language)}
            >
              {truncate(ifArabic(blog.TitleAr, blog.Title), ifArabic(77, 60))}
            </Link>
          </h3>
        )}
        <div className="tp-blog-meta">
          <span>
            <span className={ifArabic("letter-spacing-5", "")}>
              <ClockSvg />
              {convertToDate(blog.PublishDate).toString()}
            </span>
          </span>
        </div>
        <div className="tp-blog-btn">
          <Link
            aria-label="Read More"
            href={getLocalizedPath(`/news/${blog.UniqueUrl}`, language)}
          >
            <span className="tp-blog-btn-bg blog-btn-bg"></span>
            <span className="tp-blog-btn-border blog-btn-border"></span>
            <span className="icon">
              {ifArabic(<ArrowIcons.PreviousArrow />, <ArrowIcons.NextArrow />)}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
